import axios from 'axios';

// if (!process.env.REACT_APP_API_BASE) {
// 	console.error('REACT_APP_API_BASE variable not loaded properly. Check your .env file please!');
// }

export default axios.create({
	baseURL: process.env.REACT_APP_API_BASE,
	timeout: 50000
});